if($('.type-page').length){
    $('form#validateZip').on('submit', function(e) {
        e.preventDefault();
        $('.deliveryRow').remove();
        var userZip = $('#zip').val().replace(/\s/g, '');
        if (userZip.length === 5 && /^\d+$/.test(userZip)) {
            var csvData = JSON.parse(sessionStorage.getItem('csvDataCombined'));
            if (csvData) {
                var foundRecords = csvData.filter(function(row) {
                    return row.PSC === userZip; // Porovnání PSČ
                });
                if (foundRecords.length > 0) {
                    var outputHtml = '';
                    var dopravaDisplayed = false;
                    foundRecords.forEach(function(found) {
                        if (found['ID-DOPRAVY'] === '') {
                            if (found['název dodacího místa']) {
                                outputHtml += '<div class="deliveryRow places green">V této obci prodáváme v ' + found['název dodacího místa'] + ' na adrese ' + found['ulice'] + ' ' + found['č.p.'] + ', ' + found['PSC'] + ' ' + found['obec'] + '.</div>';
                            }
                            outputHtml += '<div class="deliveryRow alert">Litujeme, ale do Vaší oblasti nedoručujeme.</div>';
                        } else {
                            if (found['název dodacího místa']) {
                                outputHtml += '<div class="deliveryRow places green">V této obci prodáváme v ' + found['název dodacího místa'] + ' na adrese ' + found['ulice'] + ' ' + found['č.p.'] + ', ' + found['PSC'] + ' ' + found['obec'] + '.</div>';
                            }
                            if (found['NAZEV-DOPRAVY'] && !dopravaDisplayed) {
                                outputHtml += '<div class="deliveryRow green doprava">' + found['NAZEV-DOPRAVY'] + '</div>';
                                dopravaDisplayed = true;
                            }
                        }
                    });
                    $(this).after(outputHtml);
                } else {
                    var zipPrefix = userZip.substring(0, 2);
                    $(this).after('<div class="deliveryRow alert">Litujeme, ale do Vaší oblasti nedoručujeme.</div>');
                }
            } else {
                // Nejsou načtená žádná data
            }
        } else {
            // Neplatné PSČ
            $(this).after('<div class="deliveryRow alert">Zadejte PSČ ve správném formátu, například 755 01.</div>');
        }
    });
}